import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Order} from '../../models';
import {environment} from '~environments/environment';

/**
 * Get orders from customers.
 */
@Injectable()
export class MerchandisingService {
  public API_URL: any = `${environment.envAPI}`;
  public limitItems: number = 5;

  constructor(private http: HttpClient) {
  }

  /**
   * Get all orders for a customer. By default get maximum of 5 orders.
   */
  public getAll(
    customerId: number,
    page: number = 1,
    limit: number = this.limitItems
  ): Observable<Array<Order>> {
    const pageStr = String(page);
    const limitStr = String(limit);

    const params: HttpParams = new HttpParams({
      fromObject: {
        page: pageStr,
        itemsPerPage: limitStr
      }
    });

    return this.http.get(
      `${this.API_URL}/customers/${customerId}/orders?order[dateTime]=desc`,
      {params}
    )
      .pipe(
        map((response: Array<Order>) => response['hydra:member'].map(order => new Order(order)))
      );
  }

  /**
   * Get all reminders for a customer with a specific status.
   */
  public getCustomerOrdersEndpoint(customerId: number): any {
    const api = `${this.API_URL}/customers/${customerId}/orders`;

    const params: Array<any> = [
      {'order[dateTime]': 'desc'},
    ];

    return [api, params];
  }
}
